export default __webpack_public_path__ + "static/media/CogTest-Man-Woman-Exercise-sm.7122058e.svg";